<div class="flex flex-col gap-1 w-full">
  <div>
    <span class="text-xs text-slate-400">
      {{ "Firma" | transloco }}
    </span>
  </div>

  <div class="flex flex-row flex-1 p-2 gap-2 w-full">
    @for (signature of signatureHtml(); track $index) {
      <div
        [innerHTML]="signature"
        class="flex w-full"
        [ngClass]="{
          'justify-start': align() === 'left',
          'justify-center': align() === 'center',
          'justify-end': align() === 'right'
        }"
      ></div>
    }
  </div>
</div>
